<template>
  <!-- rejectTransfer Modal -->
  <div
    class="modal fade"
    id="rejectTransferModal"
    tabindex="-1"
    aria-labelledby="rejectTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rejectTransferModalLabel">
            Reject Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb3-3">
            Are you sure you want to reject the selected Transfer?
          </div>
          <div class="mb-3">
            <span
              type="button"
              class="btn btn-secondary btn-selected position-relative"
              style="margin-right: 10px; margin-top: 16px"
              >{{ props.transferName }}</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="rejectTransfer"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- approveTransfer Modal -->
  <div
    class="modal fade"
    id="approveTransferModal"
    tabindex="-1"
    aria-labelledby="approveTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="approveTransferModalLabel">
            Approve Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            Are you sure you want to approve the selected Transfer?
          </div>
          <div class="mb-3">
            <span
              type="button"
              class="btn btn-secondary btn-selected position-relative"
              style="margin-right: 10px; margin-top: 16px"
              >{{ props.transferName }}</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="approveTransfer"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- retryTransfer Modal -->
  <div
    class="modal fade"
    id="retryTransferModal"
    tabindex="-1"
    aria-labelledby="retryTransferModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="retryTransferModalLabel">
            Retry Transfer Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="workflowSelection" class="form-label"
              >Please select reprocess workflow</label
            >
            <select
              v-model="inputWorkflow"
              id="workflowSelection"
              class="form-select"
            >
              <option v-for="data in workflowData" :value="data['id']">
                {{ data["name"] }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            Are you sure you want to retry the selected Transfer?
          </div>
          <div class="mb-3">
            <span
              type="button"
              class="btn btn-secondary btn-selected position-relative"
              style="margin-right: 10px; margin-top: 16px"
              >{{ props.transferName }}</span
            >
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-danger"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="retryTransfer"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useWorkflowStore } from "@/stores/content_review/new_workflow_definition";
import { useTransferStore } from "@/stores/content_review/transfer";
import { ref, watch, onMounted } from "vue";

const workflowStore = useWorkflowStore();
const transferStore = useTransferStore();
const workflowData = ref([{}]);
const inputWorkflow = ref();
const emit = defineEmits(["listen-refresh-table"]);

const props = defineProps({
  transferId: { type: String },
  transferName: { type: String },
});
const selectedTransferId:any = ref(props.transferId);


onMounted(() => {
  workflowStore.fetchWorkflow();
});

watch(
  () => props.transferId,
  (newTransferId) => (selectedTransferId.value = newTransferId)
);

watch(
  () => workflowStore.workflowList,
  (val) => (workflowData.value = val)
);

const rejectTransfer = async () => {
  await transferStore.rejectTransfer(selectedTransferId.value);
};

const approveTransfer = async () => {
  await transferStore.approveTransfer(selectedTransferId.value);
};

const retryTransfer = async () => {
  if (!inputWorkflow.value) return;
  await transferStore.retryTransfer(selectedTransferId.value);
  inputWorkflow.value = "";
};

// Per SIP ID LOOP
// for (let index = 0; index < sipId.value.length; index++) {
//   const id: string = sipId.value[index];
//   console.log("Pass:", id);
//   transferStore.approveTransfer(id);
//   emit("listen-ingestion", approveTransfer);
// }
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
.btn-selected:hover {
  background: #6c757d;
  cursor: default;
}
</style>
